import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@cargomatic/ui';
import Pagination from 'components/v2/PaginationV2';

const ROWS_PER_PAGE = 10;

const EventList = ({ rows, columns }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [rows]);

  const totalPages = Math.ceil(rows.length / ROWS_PER_PAGE);
  const displayRows = rows.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE,
  );

  const localizedColumns = columns.map((col) => ({
    ...col,
    text: t(col.text).toUpperCase(),
  }));

  if (!rows.length) {
    return (
      <p className="text-sm text-muted-foreground py-4">{t('NO_DATA_FOUND')}</p>
    );
  }

  return (
    <div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {localizedColumns.map((col) => (
                <TableHead key={col.dataField} className="whitespace-nowrap">
                  {col.text}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {displayRows.map((row, rowIndex) => (
              <TableRow key={row._id || rowIndex}>
                {localizedColumns.map((col) => (
                  <TableCell key={col.dataField} className="whitespace-nowrap">
                    {col.formatter
                      ? col.formatter(row[col.dataField], row)
                      : row[col.dataField] || ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {totalPages > 1 && (
        <Pagination
          perPage={ROWS_PER_PAGE}
          page={page}
          total={rows.length}
          onPageClick={(p) => setPage(p)}
          showCount={false}
        />
      )}
    </div>
  );
};

export default EventList;
